// chatClient.js
import { StreamChat } from "stream-chat";

const chatClient = StreamChat.getInstance("bymefp455ef2", {
	timeout: 15000,  // Set global timeout here
});

export default chatClient;
